import moment from 'moment';

export const formatDateTime = (dateString: string) => {
  return dateString ? moment(dateString) : null;
};
